module.exports = __webpack_public_path__ + "static/media/2.a5774a1c.jpg";